import * as types from '../action_types';

export const setPreviewTourPoly = (data) => {
  return {
    type: types.FETCH_PREVIEW_POLYLINE_FULFILLED,
    payload: data,
  };
};
